import { TActionType, TransactionType } from "../../../Utility/Tracking/DataSet/Transaction";
import { trackTransaction } from "../../../Utility/Tracking/TrackingHelpers/Transaction";
import { IGameState } from "../../Game/IGameState";
import { setBoosterUndo } from "../PlayerInventoryHelper";

export function receiveBoosterUndo(state: IGameState, count: number) {
    state = {
        ...state,
        playerState: setBoosterUndo(
            state.playerState,
            state.playerState.inventory.boosterUndo + count
        ),
    };
    trackTransaction(state, TransactionType.REWARD, TActionType.REWARD);
    return state;
}
